export type SectorKey = 'perakende' | 'toptan' | 'restoran';

export interface SectorConfig {
  key: SectorKey;
  name: string;
  bannerLabel: string;
  apiKeyEnvName: string;
  subdomainPrefix: string;
  accentColor?: string;
}

export const SECTORS: Record<SectorKey, SectorConfig> = {
  perakende: {
    key: 'perakende',
    name: 'Perakende',
    bannerLabel: 'Canlı demo · Perakende',
    apiKeyEnvName: 'VITE_DEMO_PERAKENDE_API_KEY',
    subdomainPrefix: 'demo-perakende',
  },
  toptan: {
    key: 'toptan',
    name: 'Toptan',
    bannerLabel: 'Canlı demo · Toptan / B2B',
    apiKeyEnvName: 'VITE_DEMO_TOPTAN_API_KEY',
    subdomainPrefix: 'demo-toptan',
  },
  restoran: {
    key: 'restoran',
    name: 'Restoran',
    bannerLabel: 'Canlı demo · Restoran / F&B',
    apiKeyEnvName: 'VITE_DEMO_RESTORAN_API_KEY',
    subdomainPrefix: 'demo-restoran',
  },
};

export const DEFAULT_SECTOR: SectorKey = 'perakende';

export function parseSectorFromHostname(hostname: string): SectorKey | null {
  const match = hostname.match(/^demo-([a-z]+)\./);
  if (!match) return null;
  const key = match[1];
  return key in SECTORS ? (key as SectorKey) : null;
}
